import React, { Component } from 'react';
import { Switch, Tooltip, Button, Spin, Empty, Modal, notification, Tabs, Avatar, Pagination, Table,Select } from 'antd';
import { UndoOutlined, CloseOutlined, UserOutlined } from '@ant-design/icons';
import networkList from '../../../constants/networkList';
// import postService from '../../services/httpService';
import postService from '../../../services/httpService';
import { addconsents } from '../../../schema/on-bad-patient';
import Select2multiple from '../../../components/FormComponent/select2/multiple';
import Storage from './../../../services/local-store';
import { investigation, drugs, procedures } from './../../../schema/investigation';
import Tableantd from './../../../components/FormComponent/table/antd';
import ReactToPrint from "react-to-print";

// import CustomLoader from '../../components/loader';

import moment from 'moment';
const { Option } = Select;
const { TabPane } = Tabs;
const { saveConsentNurseRequest, getConsentsDetailsForPatient, getConsentsListForPatient,getCounsellingDetailsByIP, homepage } = networkList;
class On_Bed_Patient_details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadding: false,
            message: null,
            thead: [{
                'id': 1,
                'text': 'Consent Id',
                'name': 'consent_id',
                'visible': true,
                'className': null
            }, {
                'id': 2,
                'text': 'Nurse',
                'name': 'nurse',
                'visible': true,
                'className': null
            }, {
                'id': 3,
                'text': 'Counsellor',
                'name': 'counsellor',
                'visible': true,
                'className': null
            },
            // {
            //     'id': 5,
            //     'text': 'Datetime',
            //     'name': 'created_at',
            //     'visible': true,
            //     'className': null

            // },
            {
                'id': 6,
                'text': 'IP No',
                'name': 'ip_no',
                'visible': true,
                'className': null

            }, {
                'id': 7,
                'text': 'UMR No',
                'name': 'umr_no',
                'visible': true,
                'className': null

            }],
            consents_head: [
                // {
                //     'id': 1,
                //     'title': 'S.No.',
                //     'key': 's_no',
                //     'dataIndex': 'consent_id',
                //     'visible': true,
                //     'className': 'text-center'
                // },
                {
                    'id': 2,
                    'title': 'Consent ID',
                    'key': 'consent_id',
                    'dataIndex': 'consent_id',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                },{
                    'id': 3,
                    'title': 'IP No.',
                    'key': 'ip_no',
                    'dataIndex': 'ip_no',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'title': 'UMR No.',
                    'key': 'umr_no',
                    'dataIndex': 'umr_no',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'title': 'consent name',
                    'key': 'consent_name',
                    'dataIndex': 'consent_name',
                    'visible': true,
                    'className': null
                },  {
                    'id': 4,
                    'title': 'consent type',
                    'key': 'consent_type',
                    'dataIndex': 'consent_type',
                    'visible': true,
                    'className': null
                }, {
                    'id': 6,
                    'title': 'Status',
                    'key': 'approval_status',
                    'visible': true,
                    'dataIndex': 'approval_status',
                    'className': null
                },{
                    'id': 4,
                    'title': 'rejected reason',
                    'key': 'reject_reason',
                    'dataIndex': 'reject_reason',
                    'visible': true,
                    'className': null
                },                
                {
                    'id': 6,
                    'title': 'Counsellor Submitted ?',
                    'key': 'is_counsellor_submitted',
                    'dataIndex': 'is_counsellor_submitted',
                    'visible': true,
                    'className': null
                },{
                    'id': 4,
                    'title': 'General price (Rs.)',
                    'key': 'general_price',
                    'dataIndex': 'general_price',
                    'visible': true,
                    'className': null
                },{
                    'id': 4,
                    'title': 'price (Rs.)',
                    'key': 'price',
                    'dataIndex': 'price',
                    'visible': true,
                    'className': null
                },{
                    'id': 7,
                    'title': 'Counsellor',
                    'key': 'counsellor',
                    'dataIndex': 'counsellor',
                    'visible': true,
                    'className': null
                },{
                    'id': 4,
                    'title': 'Nurse',
                    'key': 'nurse',
                    'dataIndex': 'nurse',
                    'visible': true,
                    'className': null
                },

            ],
            counseling_head: [
                {
                    'id': 1,
                    'title': 'S.No.',
                    'key': 's_no',
                    'dataIndex': 's_no',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 2,
                    'title': 'Date Of Counselling',
                    'key': 'date_of_counselling',
                    'dataIndex': 'date_of_counselling',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 3,
                    'title': 'Total Estimate Amount',
                    'key': 'total_estimate_amt',
                    'dataIndex': 'total_estimate_amt',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'title': 'Counselled By',
                    'key': 'counselled_by',
                    'dataIndex': 'counselled_by',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                },  {
                    'id': 5,
                    'title': 'Privilege Name',
                    'key': 'privilege_name',
                    'dataIndex': 'privilege_name',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                }, {
                    'id': 6,
                    'title': 'Payment Type',
                    'key': 'payment_type',
                    'visible': true,
                    'dataIndex': 'payment_type',
                    'fixed': 'left',
                    'className': null
                },
                {
                    'id': 7,
                    'title': 'Action',
                    'key': 'action',
                    'visible': true,
                    'dataIndex': 'action',
                    'className': null
                },

            ],
            assigned_task_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                }, {
                    'id': 2,
                    'text': 'task name',
                    'name': 'task_name',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'frequency',
                    'name': 'frequency',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'days',
                    'name': 'days',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'from date time',
                    'name': 'from_date_time',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'to date time',
                    'name': 'to_date_time',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'text': 'Status',
                    'name': 'status',
                    'visible': true,
                    'className': null
                }
            ],
            all_task_body: [],
            assigned_task_body: [],
            data: [],
            commentModal: false,
            'formData': addconsents['feilds'],
            consentdetalsvisible: false,
            investigations_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Investigation Name',
                    'name': 'investigation_name',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 3,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                }, {
                    'id': 5,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                }, {
                    'id': 6,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            investigations_body: [],
            drug_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Drug Name',
                    'name': 'drug_name',
                    'visible': true,
                    'className': 'text-center'
                }, {
                    'id': 3,
                    'text': 'Quantity',
                    'name': 'quantity',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Price (Rs.)',
                    'name': 'drug_price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Total (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 6,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            durg_body: [],
            procedures_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Procedures Name',
                    'name': 'procedure_name',
                    'visible': true,
                    'className': 'text-center'
                }, {
                    'id': 3,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 6,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            procedures_body: [],
            page_no: 1,
            totalItemsCount: 0,
            information: [
                {
                    "key": 'patient_name',
                    'text': 'patient name'
                }, {
                    "key": 'umr_no',
                    'text': 'UMR'
                }, {
                    "key": 'mobile_number',
                    'text': 'phone number'
                }, {
                    "key": 'patient_age',
                    'text': 'age',
                }, {
                    "key": 'patient_gender',
                    'text': 'gender'
                }, {
                    "key": 'unit_name',
                    'text': 'unit name'
                }
                ,{
                    "key": 'patient_ip_number',
                    'text': 'IP'
                },{
                    "key": 'bed_no',
                    'text': 'Bed number'
                }
            ],
            patient_details: [],
            investigationSchema: investigation['feilds'],
            drugsSchema: drugs['feilds'],
            proceduresSchema: procedures['feilds'],
            investigationSelectID: [],
            drugsSelectID: [],
            proceduresSelectID: [],
            counseling_Data:[],
            activeTab:'1',
            FC_PRIVILEGE_IDS:[],
            "showAdd": false,
            consentPrintVisibles:false,
            selet_options:[],
            investigations_body_print:[],
            durg_body_print:[],
            procedures_body_print:[],
            consentdetalsvisible_print:false,
        }
            this.inputChange = this.inputChange.bind(this);

    }
    componentDidMount() {
       
        const params = new URLSearchParams(this.props.location.search);
        let tab = params.get('tab');
        if(tab==='' || tab ===null || tab===undefined){
            tab='1';
        }
        const data = JSON.parse(localStorage.getItem('patient_details'));
        this.setState({
            patient_details: [data],activeTab:tab
        })
        this.fetchListData();
        const { id, slug } = this.props.match.params
        const { getRolePermissions } = networkList;
        postService(getRolePermissions, 'GET', null).then(res => {
            console.log(res)
            if (res.status) {
                let showAdd 
                res.data.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (slug === 'on-bed-patient-details' ) {
                                    menu['submenu'].map((srmenu) => {
                                        if (srmenu['route'] === 'onbed-patients') {
                                            showAdd = JSON.parse(srmenu['permissions']['add']);
                                            this.setState({showAdd:showAdd})
                                        }
                                    });
                                }
                                
                            })
                        }
                    }
                })
                this.setState((state) => ({ menuList: res.data }));
            }
        })
        
        

    }

    fetchListData() {
        const params = new URLSearchParams(this.props.location.search);
        const patient_ip = params.get('patient_ip');
        const umr_no = params.get('umr_no');
        this.setState((state) => ({ tbody: [], loadding: false }));
        let user_data = JSON.parse(localStorage.getItem('user_data'));
        let { page_no, consents_head } = this.state;
        try {
            // postService(getConsentsListForPatient, 'POST', { 'data': { "page_no": page_no,"unit_id":user_data['unitid'],"ip_no":patient_ip} }).then(res => {
            postService(getConsentsListForPatient, 'POST', { 'data': { "page_no": page_no, "unit_id": user_data['unitid'], "ip_no": patient_ip } }).then(res => {
                if (res.status) {
                    if (res['data'] && res['data'].length>0) {
                        res['data'].map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'approval_status') {
                                    if (res.data[key][dataKey] === 'approve') {
                                        res['data'][key][dataKey] = ((res['data'][key][dataKey] && res['data'][key][dataKey] !== '-') || res['data'][key][dataKey] == 0) ? 'Approved' : '---'                                        
                                    } else if (res.data[key][dataKey] === 'reject') {
                                        res['data'][key][dataKey] = ((res['data'][key][dataKey] && res['data'][key][dataKey] !== '-') || res['data'][key][dataKey] == 0) ? 'Rejected' : '--'
                                    }else{
                                        res['data'][key][dataKey] = ((res['data'][key][dataKey] && res['data'][key][dataKey] !== '-') || res['data'][key][dataKey] == 0) ? 'Pending' : 'Pending'
                                    }
                                    
                                }else if (dataKey === 'is_counsellor_submitted') {
                                    res['data'][key][dataKey] = ((res['data'][key][dataKey] && res['data'][key][dataKey] !== '-') || res['data'][key][dataKey] == 0) ? 'YES' : 'NO'                                        
                                }else{
                                    res['data'][key][dataKey] = ((res['data'][key][dataKey] && res['data'][key][dataKey] !== '-') || res['data'][key][dataKey] == 0) ? res['data'][key][dataKey] : 'NA'
                                }
                            })})

                        res['data'].map((data, tkey) => {
                            consents_head.map((head, Hkey) => {
                                if (head['name'] === 'approval_status') {
                                    if (data[head['name']]) {
                                        return data[head['name']] === 'approve' ? 'Approved' : 'Rejected'
                                    } else {
                                        return data[head['name']] ? data[head['name']] : '--'
                                    }
                                }
                                if (head['name'] === 'is_counsellor_submitted') {
                                    return data['is_counsellor_submitted'] === 1 ? 'YES' : 'NO'
                                }
                                if (head['name'] === 'counsellor') {
                                    return data['counsellor'] ? data['counsellor'] : '--'
                                }
                                return data[head['name']] ? data[head['name']] : '--'
                            })
                        })

                        this.setState((state) => ({
                            all_task_body: res['data'],
                            message: res.message,
                            totalItemsCount: res.total_items,
                            loadding: false
                        }));
                    }
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ loadding: false }));

            Modal.error({
                title: 'Failure',
                content: 'Oops, something is wrong. Please try again.',
            })

        }

        try{
            postService(getCounsellingDetailsByIP, 'POST', { 'data': { "umr_no": umr_no,"ip_no": patient_ip ,"unit_id": user_data['unitid']} }).then(res => {
                if (res.status) {
                    if (res['data'] && res['data'].length>0) {
                        this.setState({
                            counseling_Data: res['data'],FC_PRIVILEGE_IDS:res['FC_PRIVILEGE_IDS']

                        })
                    }
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
        }catch(error){
            console.log(error);
            this.setState((state) => ({ loadding: false }));
            Modal.error({
                title: 'Failure',
                content: 'Oops, something is wrong. Please try again.',
            })
        }

       


    }
    handleChange2(ele) {
        console.log(ele);
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get('id');
        if (ele.text == "MEWS") {
            this.props.history.push('/dmo-mews?patient_id=' + id + `&task_pid=` + ele.task_pid + `&task_code=` + ele.value)
        }

    }
    backClick() {
        this.props.history.push('/patients/onbed-patients');
    }
    allocation_task_rowClicked = (data) => {

        if (data['task_id'] === 'TID5') {
            this.props.history.push(`/dmo-mews/view?patient_id=${data.patient_id}&task_code=${data.task_id}&task_unique_id=${data.task_unique_id}`)
        } else if (data['task_id'] === 'TID16') {
            this.props.history.push(`/initial_assessment/view?patient_id=${data.patient_id}&task_code=${data.task_id}&task_unique_id=${data.task_unique_id}`)
        }
    }
    assigned_task_rowClicked = (data) => {
        this.setState({ consentdetalsvisible: true })
        try {
            postService(getConsentsDetailsForPatient, 'POST', {
                'data': {
                    "consent_id": data ?
                        data.consent_id : null,
                }
            }).then(res => {
                if (res.status) {
                    this.setState((state) => ({

                        investigations_body: data.investigations,
                        durg_body: res['data'].drugs,
                        procedures_body: res['data'].procedures,
                        data: res['data'],
                        loadding: false,
                    }));
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ loadding: false }));

            Modal.error({
                title: 'Failure',
                content: 'Oops, something is wrong. Please try again.',
            })

        }
        // if (data['task_id'] === 'TID5') {
        //     this.props.history.push('/nurse-patient-mews/view?patient_id=' + data.patient_id + `&task_id=` + data.task_id + `&task_time=` + data.task_time + `&task_status=` + data.status + '&action_unique_id=' + data.action_unique_id)
        // } else if (data['task_id'] === 'TID16') {
        //     this.props.history.push('/nurse_initial_assessment/view?patient_id=' + data.patient_id + `&task_id=` + data.task_id + `&task_time=` + data.task_time + `&task_status=` + data.status + '&action_unique_id=' + data.action_unique_id)
        // }
    }
    modelVisisableAddConsent = () => {

        let { investigationSchema, drugsSchema, proceduresSchema } = this.state;
        investigationSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            investigationSchema[key].Specification.add_more = true;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    if (table_key === 0) {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'investigation_name') {
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        })
                    } else {
                        investigationSchema[key].Specification.table_body.splice(table_key, 1)
                    }
                }
            })
        })

        drugsSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            drugsSchema[key].Specification.add_more = true;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    if (table_key === 0) {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'drugs_name') {
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        })
                    } else {
                        drugsSchema[key].Specification.table_body.splice(table_key, 1)
                    }
                }
            })
        })

        proceduresSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            proceduresSchema[key].Specification.add_more = true;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    if (table_key === 0) {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'procedures_name') {
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        })
                    } else {
                        proceduresSchema[key].Specification.table_body.splice(table_key, 1)
                    }
                }
            })
        })

        this.setState({
            commentModal: false, comments: null,
            investigationSchema:investigation['feilds'], drugsSchema:drugs['feilds'],proceduresSchema:procedures['feilds']
        })
        setTimeout(() => { this.setState({commentModal: true,investigationSchema:JSON.parse(JSON.stringify(investigation['feilds'])), drugsSchema:JSON.parse(JSON.stringify(drugs['feilds'])), proceduresSchema:JSON.parse(JSON.stringify(procedures['feilds'])) }) }, 1000)
    }
    handleChange(data) {
        let { investigationSchema, drugsSchema, proceduresSchema ,investigationSelectID,drugsSelectID,proceduresSelectID} = this.state;
        if (data) {
            if (Array.isArray(data)) {
                investigationSchema.map((subTable, key) => {
                    let table_name = data[0].feilds[0].table;
                    if (subTable.name === table_name) {
                        let table_body = subTable.Specification.table_body;
                        investigationSchema[key].Specification.table_body = table_body.concat(data);
                    }
                })
                drugsSchema.map((subTable, key) => {
                    let table_name = data[0].feilds[0].table;
                    if (subTable.name === table_name) {
                        let table_body = subTable.Specification.table_body;
                        drugsSchema[key].Specification.table_body = table_body.concat(data);
                    }
                })
                proceduresSchema.map((subTable, key) => {
                    let table_name = data[0].feilds[0].table;
                    if (subTable.name === table_name) {
                        let table_body = subTable.Specification.table_body;
                        proceduresSchema[key].Specification.table_body = table_body.concat(data);
                    }
                })
                this.setState({ investigationSchema: investigationSchema, drugsSchema: drugsSchema, proceduresSchema: proceduresSchema });
            } else {
                let data_value;
                drugsSchema.map((subTable, key) => {
                    if (subTable.name === data.tableName) {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
                                data_value = data.value;
                            }
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                    drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data_value;
                                }
                            })
                        })
                    }
                })
                this.setState({ investigationSchema: investigationSchema, drugsSchema: drugsSchema, proceduresSchema: proceduresSchema });
            }
          
          if(data.name==='investigation_name'){
            if (data.value !== '' && data.value !== undefined && data.value !== null) {
                const index = investigationSelectID.map(item => item.id).indexOf( data.id);
                if (index > -1) {
                    investigationSelectID[index].value = data.value;
                } else {
               let  payload={
                            "id": data.id,
                          "value":data.value };
                    investigationSelectID.push(payload)
                }
                this.setState({ investigationSelectID });
            }
            

          }
          if(data.name==='drugs_name'){
            if (data.value !== '' && data.value !== undefined && data.value !== null) {
                const index = drugsSelectID.map(item => item.id).indexOf( data.id);
                if (index > -1) {
                    drugsSelectID[index].value = data.value;
                } else {
              let   payload={
                            "id": data.id,
                          "value":data.value };
                    drugsSelectID.push(payload)
                }
                this.setState({ drugsSelectID });
            }
            

          }
          if(data.name==='procedures_name'){
            if (data.value !== '' && data.value !== undefined && data.value !== null) {
                const index = proceduresSelectID.map(item => item.id).indexOf( data.id);
                if (index > -1) {
                    proceduresSelectID[index].value = data.value;
                } else {
              let   payload={
                            "id": data.id,
                          "value":data.value };
                    proceduresSelectID.push(payload)
                }
                this.setState({ proceduresSelectID });
            }
            

          }
          
        }

    }

    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;

        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error', formFeilds)
        this.setState((state) => ({ investigations: formFeilds }));
        return errors;
    }
    validateModalFeilds2(formFeilds) {
        let errors = [];
        let role_id = null;

        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined) || (feild['value'] === 0)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error', formFeilds)
        this.setState((state) => ({ drugsSchema: formFeilds }));
        return errors;
    }
    validateModalFeilds3(formFeilds) {
        let errors = [];
        let role_id = null;

        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error', formFeilds)
        this.setState((state) => ({ proceduresSchema: formFeilds }));
        return errors;
    }
    deleteRow(data) {
       
        let { investigationSchema, drugsSchema, proceduresSchema,investigationSelectID ,drugsSelectID,proceduresSelectID} = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let table_name = data[0].feilds[0].table;
        let last_id = data[0].feilds[0].id;
        let newData = [];
        if (Array.isArray(data)) {
            investigationSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            investigationSchema[key].Specification.table_body.splice(table_key, 1);

                        }
                    })
                }
            })

            drugsSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            drugsSchema[key].Specification.table_body.splice(table_key, 1);

                        }
                    })
                }
            })

            proceduresSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            proceduresSchema[key].Specification.table_body.splice(table_key, 1);

                        }
                    })
                }
            })
        }
        if(data[0].feilds[0].name==='investigation_name'){
        const filterIds = investigationSelectID.filter(item => item.id !== data[0]['id']);
        this.setState({investigationSelectID:filterIds});
    }
    if(data[0].feilds[0].name==='drugs_name'){
        const filterIds = drugsSelectID.filter(item => item.id !== data[0]['id']);
        this.setState({drugsSelectID:filterIds});
    }
    if(data[0].feilds[0].name==='procedures_name'){
        const filterIds = proceduresSelectID.filter(item => item.id !== data[0]['id']);
        this.setState({proceduresSelectID:filterIds});
    }
        this.setState({ investigationSchema, drugsSchema, proceduresSchema }, () => {
        })
    }

    submitConsent() {
        let { investigationSchema, drugsSchema, proceduresSchema } = this.state;
        const params = new URLSearchParams(this.props.location.search);
        const patient_ip = params.get('patient_ip');
        const umr_no = params.get('umr_no');
        var formFeilds = this.state.formData;
        let user_data = JSON.parse(localStorage.getItem('user_data'));
        let investigation = [];
        let drugs = [];
        let procedures = [];


        investigationSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let investigation_id;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                investigation_id = parseFloat(sub_feild.value);
                                if (investigation_id !== '' && investigation_id !== null && investigation_id !== undefined && !isNaN(investigation_id)) {
                                    investigation.push(parseFloat(sub_feild.value));
                                }
                            }
                        }
                    })
                })
            }
        })


        proceduresSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let procedures_id;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                procedures_id = parseFloat(sub_feild.value);
                                if (procedures_id !== '' && procedures_id !== null && procedures_id !== undefined && !isNaN(procedures_id)) {
                                    procedures.push(parseFloat(sub_feild.value));
                                }
                            }
                        }
                    })
                })
            }
        })

        drugsSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let drugs_id, quantity, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                drugs_id = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 1) {
                                quantity = parseFloat(sub_feild.value);
                            }

                        }
                    })
                    let obj = {
                        "drug_id": drugs_id,
                        "quantity": quantity,
                    }
                    if (drugs_id !== '' && drugs_id !== null && drugs_id !== undefined && !isNaN(drugs_id) && quantity !== '' && quantity !== null && quantity !== undefined && !isNaN(quantity)) {
                        drugs.push(obj);
                    }
                    if(drugs_id !== '' && drugs_id !== null && drugs_id !== undefined && !isNaN(drugs_id) && (isNaN(quantity) || quantity === '' || quantity === null || quantity === undefined)){
                        procedures=[];
                        investigation=[];
                    }
                })
            }
        })

        console.log(investigation, drugs, procedures);
        // let errors = this.validateModalFeilds(formFeilds);        
        let error = this.validateModalFeilds(investigationSchema)
        let error2 = this.validateModalFeilds2(drugsSchema)
        let error3 = this.validateModalFeilds3(proceduresSchema)
        if(!error.includes(false) || !error2.includes(false) || !error3.includes(false)){
        if ((investigation && investigation.length > 0) || (drugs && drugs.length > 0) || (procedures && procedures.length > 0)) {            
            try {
                postService(saveConsentNurseRequest, 'POST', {
                    'data': {
                        "unit_id": user_data['unitid'],
                        "umr": umr_no,
                        "ip_number": patient_ip,
                        'investigations': investigation ? investigation : [],
                        'procedures': procedures ? procedures : [],
                        'drugs': drugs ? drugs : [],
                    }
                }).then(res => {
                    if (res.status) {
                        this.fetchListData()
                        this.setState({ commentModal: false });
                        investigationSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            investigationSchema[key].Specification.add_more = true;
                            table_body.map((feild, table_key) => {
                                if (table_body.length > 0) {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'investigation_name') {
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }

                                        })
                                    } else {
                                        investigationSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                            })
                        })

                        drugsSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            drugsSchema[key].Specification.add_more = true;
                            table_body.map((feild, table_key) => {
                                if (table_body.length > 0) {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'drugs_name') {
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }

                                        })
                                    } else {
                                        drugsSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                            })
                        })

                        proceduresSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            proceduresSchema[key].Specification.add_more = true;
                            table_body.map((feild, table_key) => {
                                if (table_body.length > 0) {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'procedures_name') {
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }

                                        })
                                    } else {
                                        proceduresSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                            })
                        })

                        setTimeout(() => { this.setState({ investigationSchema, drugsSchema, proceduresSchema,investigationSelectID: [],
                            drugsSelectID: [],
                            proceduresSelectID: [] }) }, 1000)
                        this.setState({
                            loadding: false,
                            investigationSchema, drugsSchema, proceduresSchema
                        })
                        Modal.success({
                            title: 'Success message',
                            content: res.message ? res.message : 'consent Added Successfully',
                        }
                        );
                    } else {
                        investigationSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            investigationSchema[key].Specification.add_more = true;
                            table_body.map((feild, table_key) => {
                                if (table_body.length > 0) {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'investigation_name') {
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }

                                        })
                                    } else {
                                        investigationSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                            })
                        })

                        drugsSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            drugsSchema[key].Specification.add_more = true;
                            table_body.map((feild, table_key) => {
                                if (table_body.length > 0) {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'drugs_name') {
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }

                                        })
                                    } else {
                                        drugsSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                            })
                        })

                        proceduresSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            proceduresSchema[key].Specification.add_more = true;
                            table_body.map((feild, table_key) => {
                                if (table_body.length > 0) {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'procedures_name') {
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }

                                        })
                                    } else {
                                        proceduresSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                            })
                        })
                        setTimeout(() => { this.setState({ investigationSchema, drugsSchema, proceduresSchema }) }, 1000)
                        this.setState({
                            loadding: false,
                            investigationSchema, drugsSchema, proceduresSchema,investigationSelectID: [],
                            drugsSelectID: [],
                            proceduresSelectID: []
                        })
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                        })
                    }
                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ loadding: false }));

                Modal.error({
                    title: 'Failure',
                    content: 'Oops, something is wrong. Please try again.',
                })

            }
        } 
        // else {
        //     Modal.error({
        //         title: 'Failure',
        //         content: 'Please fill any one of the fields',
        //         zIndex: '1022'
        //     })
        // }
    }
    }
    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }
    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            page_no: page,
            assigned_patient: []
        }), () => {
            this.fetchListData();
        })
    }
    addConsentModelClose() {
        let { investigationSchema, drugsSchema, proceduresSchema } = this.state;
        investigationSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            investigationSchema[key].Specification.add_more = true;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    if (table_key === 0) {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'investigation_name') {
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                investigationSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        })
                    } else {
                        investigationSchema[key].Specification.table_body.splice(table_key, 1)
                    }
                }
            })
        })

        drugsSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            drugsSchema[key].Specification.add_more = true;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    if (table_key === 0) {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'drugs_name') {
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                drugsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        })
                    } else {
                        drugsSchema[key].Specification.table_body.splice(table_key, 1)
                    }
                }
            })
        })

        proceduresSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            proceduresSchema[key].Specification.add_more = true;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    if (table_key === 0) {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'procedures_name') {
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                proceduresSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        })
                    } else {
                        proceduresSchema[key].Specification.table_body.splice(table_key, 1)
                    }
                }
            })
        })
        setTimeout(() => { this.setState({ investigationSchema, drugsSchema, proceduresSchema }) }, 1000)
        this.setState({
            commentModal: false, comments: null,
            investigationSchema, drugsSchema, proceduresSchema,investigationSelectID: [],
            drugsSelectID: [],
            proceduresSelectID: []
        })
    }

    navigateTo(data) {
        let {counselling_id, ip_no, privilige_id,  umr_no, unit_id,payment_type,payment_type_id,form_type}= data
        let {FC_PRIVILEGE_IDS}=this.state;
        let id = counselling_id
        let ip = ip_no
        let umr = umr_no
        let unit = unit_id 
        let payment = null 
        if(payment_type){
            if(payment_type === 'Cash'){
                payment = '1'
            }else if(payment_type === 'Insurance'){
                payment = '2'
            }else if(payment_type === 'Corporate'){
                payment = '3'
            }
        }
        console.log('yes',data)
        // data['counselling_id'], data['ip_no'], data['privilige_id'],data['FC_PRIVILEGE_IDS']
        // let { previlege_data } = this.state;
        window.open(`${homepage}/counselling/view-finanical-counselling?pid=${payment_type_id}&cid=${counselling_id}&fid=${form_type}`, '_blank', 'noopener,noreferrer');
        // if (FC_PRIVILEGE_IDS.includes(privilige_id)) {
        //     // if (id !== undefined && id !== null && id !== '') {
        //     //     http://103.99.110.8:3001/counselling/counselling-print?token_data=46129
        //     //     this.props
        //     //         .history
        //     //         .push(`/counselling/view-finanical-counselling?rid=${id}&umr=${umr}&unit_id=${unit}`);
        //     // } else {
        //     //     this.props
        //     //         .history
        //     //         .push(`/counselling/view-finanical-counselling?rid=${id}&ip=${ip}&umr=${umr}&unit_id=${unit}`);
        //     // }
        //     if (id !== undefined && id !== null && id !== '') {
        //         this.props
        //             .history
        //             .push(`/counselling/counselling-print?token_data=${id}&payment_type=${payment}&umr=${umr}&unit_id=${unit}&ip=${ip}&nav_from=on-bed-patients`);
        //     } else {
        //         this.props
        //             .history
        //             .push(`/counselling/counselling-print?token_data=${id}&payment_type=${payment}&umr=${umr}&unit_id=${unit}&ip=${ip}&nav_from=on-bed-patients`);
        //     }
        // }else{
        //     if (id !== undefined && id !== null && id !== '') {
        //         this.props
        //             .history
        //             .push(`/counselling/view-other-counselling?rid=${id}&umr=${umr}&unit_id=${unit}&ip=${ip}&nav_from=on-bed-patients`);
        //     } else {
        //         this.props
        //             .history
        //             .push(`/counselling/view-other-counselling?rid=${id}&ip=${ip}&umr=${umr}&unit_id=${unit}&ip=${ip}&nav_from=on-bed-patients`);
        //     }
        // }

    }
    onChange = activeKey => {
        this.setState({ activeTab:activeKey });
      };
      consentPrintVisible(consentPrintVisibles){
        this.setState({consentPrintVisibles:consentPrintVisibles})
      }
      onFocus() {
        let children = [];
       const params = new URLSearchParams(this.props.location.search);
       const patient_ip = params.get('patient_ip');
       const umr_no = params.get('umr_no');
       this.setState((state) => ({ tbody: [], loadding: false }));
       let user_data = JSON.parse(localStorage.getItem('user_data'));
       postService('getConsentsDropDownForPatient', 'POST', { "data": { "unit_id": user_data['unitid'], "ip_no": patient_ip }  }).then(res => {
        if (res['status']) {
            if (res['data'].length !== 0) {
                let dataroom=res['data'];
                  dataroom.map((data, key) => {
                    if(data.is_counsellor_submitted===1){
                        children.push(<Option key={key} value={`${data.consent_id}`}>{`${data.consent_id}`}</Option>)
                    }

                })
                this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                    // this.inputBlur();
                });
            }
        } else {
            this.setState((state) => ({ 'selet_options': [], fetching: false }));
            Modal.error({
                title: 'Error message',
                content: `${res.message}`,
            });
        }
    });
       
    }
    inputChange(value) {
            postService(getConsentsDetailsForPatient, 'POST', {
                'data': {
                    "consent_id": value ?
                    value : null,
                }
            }).then(res => {
                if (res.status) {
                    let data=res['data'];
                    if(data.is_counsellor_submitted===1){
                        let investigations_body=res['data'].investigations;
                        
                            res['data'].investigations.map((data, key) => {
                                Object.keys(data).map((dataKey) => {
                                    if (dataKey === 'approval_status') {
                                        if (res.data['investigations'][key][dataKey] === 'approve') {
                                            res['data']['investigations'][key][dataKey] = 'approve' ? 'Approved' : 'Rejected';
                                        } else if (res.data['investigations'][key][dataKey] === 'reject') {
                                            res['data']['investigations'][key][dataKey] = 'reject' ? 'Rejected' : 'Approved';
                                        } 
                                    }
                                    })

                        })
                        res['data'].drugs.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'approval_status') {
                                    if (res.data['drugs'][key][dataKey] === 'approve') {
                                        res['data']['drugs'][key][dataKey] = 'approve' ? 'Approved' : 'Rejected';
                                    } 
                                    else if (res.data['drugs'][key][dataKey] === 'reject') {
                                        res['data']['drugs'][key][dataKey] = 'reject' ? 'Rejected' : 'Approved';
                                    } 
                                }
                                })
                                
                    })
                    res['data'].procedures.map((data, key) => {
                        Object.keys(data).map((dataKey) => {
                            if (dataKey === 'approval_status') {
                                if (res.data['procedures'][key][dataKey] === 'approve') {
                                    res['data']['procedures'][key][dataKey] = 'approve' ? 'Approved' : 'Rejected';
                                } 
                                else if (res.data['procedures'][key][dataKey] === 'reject') {
                                    res['data']['procedures'][key][dataKey] = 'reject' ? 'Rejected' : 'Approved';
                                } 
                            }
                            })
                            
                })
                        this.setState({investigations_body_print: investigations_body,durg_body_print: data.drugs,procedures_body_print: data.procedures,data: data,loadding: false,consentdetalsvisible_print:true,consentPrintVisibles:false
                    }); 
                    }
                   
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
       
    }
    render() {
        const { data, message, thead, loadding, consents_head, all_task_body, assigned_task_body, assigned_task_head, commentModal, formData, consentdetalsvisible, investigations_head, investigations_body, drug_head, durg_body, procedures_head, procedures_body, totalItemsCount, page_no, information,
            patient_details, investigationSchema, drugsSchema, proceduresSchema,counseling_head,counseling_Data,activeTab,showAdd,consentPrintVisibles,selet_options,investigations_body_print,durg_body_print,procedures_body_print,consentdetalsvisible_print } = this.state;
        console.log('testing',investigationSchema);
        return (
            <React.Fragment>

                <div className="mb-5 mx-5">
                    <Spin spinning={loadding}>
                        <div className="mt-2 todolist">
                            <div className="card">
                                <div className="row p-3">
                                    {information.map((tHdata, tHkey) => {
                                        return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={tHkey}>
                                            <p className="data-label">{tHdata['text']}</p>
                                            {patient_details.length > 0 && <p className="data-item">: {(patient_details[0][tHdata['key']] && patient_details[0][tHdata['key']] !== null) ? patient_details[0][tHdata['key']] : '--'}</p>}
                                        </div>)
                                    })}
                                </div>
                            </div>
                            <Tabs onChange={this.onChange} activeKey={activeTab}  >

                                <TabPane tab="Consents" key="1">
                                    <div className="row">
                                        <div className="col-12">
                                            {showAdd && <button className="btn btn-success text-capitalize float-right" onClick={this.modelVisisableAddConsent.bind(this)}>add Consent</button>}
                                            <button className="btn btn-next text-capitalize float-right mr-2" onClick={() => this.consentPrintVisible(true)}>Print Consent </button>
                                            {/* <div className="col-4 text-right mx-auto ">
                                            <Tooltip placement="top" title='Click To Print'>
                                                <img src="/assets/images/pdf.png" className="print-pdf-img-financialclear" onClick={() => this.consentPrintVisible(true)}/>
                                            </Tooltip>
                                            {/* <p className="mb-0">Comment</p> */}
                                        {/* </div>  */}
                                        </div>
                                    </div>

                                    <div className="row p-3">
                                    <Table columns={consents_head} dataSource={all_task_body} className="consents_table" scroll={{ x: '150%'}}  pagination={{ position: ['bottomCenter'],showSizeChanger:false,pageSize:'20' }}/>
                                        {/* <div className="card-table financial-table table-responsive sticky-header d-none" id="table">
                                            <table className="table table-hover table-bordered mb-0 bg-white" style={{width: '145%'}}>
                                                <thead>
                                                   <tr> 
                                                       {consents_head.map((feild, key) => {
                                                        if (feild.visible === true) {
                                                            return (<td className="text-capitalize">{feild.text}</td>)
                                                        }
                                                    })}
                                                    </tr>
                                                </thead>
                                                <tbody className="">
                                                    {all_task_body
                                                        .map((data, tkey) => {
                                                            return (
                                                                <tr key={tkey}>
                                                                    {consents_head.map((head, Hkey) => {
                                                                        if (head['name'] === 's_no') {
                                                                            return (<td>{tkey + 1 + ((page_no - 1) * 20)}</td>)
                                                                        }
                                                                        if (head['name'] === 'consent_id') {
                                                                            return (<td>{data[head['name']] ? data[head['name']] : '--'}</td>)
                                                                        }
                                                                        if (head['name'] === 'ip_no') {
                                                                            return (<td>{data[head['name']] ? data[head['name']] : '--'}</td>)
                                                                        }
                                                                        if (head['name'] === 'nurse') {
                                                                            return (<td>{data[head['name']] ? data[head['name']] : '--'}</td>)
                                                                        }
                                                                        if (head['name'] === 'approval_status') {
                                                                            if(data[head['name']]){
                                                                                return (<td>{data[head['name']] === 'approve'? 'Approved' : 'Rejected'}</td>)
                                                                            }else{
                                                                            return (<td>{data[head['name']] ? data[head['name']] : '--'}</td>)
                                                                            }
                                                                        }
                                                                        if (head['name'] === 'is_counsellor_submitted') {
                                                                            return (<td>{data['is_counsellor_submitted'] === 1 ? 'YES' : 'NO'}</td>)
                                                                        }
                                                                        if (head['name'] === 'counsellor') {
                                                                            return (<td>{data['counsellor'] ? data['counsellor'] : '--'}</td>)
                                                                        }
                                                                        return (<td className="text-capitalize">{data[head['name']] ? data[head['name']] : '--'}</td>)

                                                                    })}
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    {(all_task_body && all_task_body.length === 0) && <React.Fragment>
                                                        <tr>
                                                            <td colSpan={consents_head.length}>
                                                                <Empty description={
                                                                    <span>
                                                                        No Data
                                                                    </span>
                                                                } />
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>}
                                                </tbody>
                                            </table>
                                        </div> */}
                                    </div>
                                    {/* <div className="col-12 justify-content-center align-item-center mx-0">
                                        <div className="col pagenation-col mb-3">
                                            <Pagination current={this.state.page_no} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={15} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />
                                        </div>
                                    </div> */}
                                    <div className="row">
                                        <div className="col-12 text-center mb-5">
                                            <button className="btn btn-next text-capitalize" onClick={this.backClick.bind(this)}>Back</button>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tab="Counsellings" key="2">
                                <div className="row p-3">
                                     <div className="card-table financial-table table-responsive sticky-header" id="table">
                                            <table className="table table-hover table-bordered mb-0 bg-white" >
                                                <thead>
                                                   <tr> 
                                                       {counseling_head.map((feild, key) => {
                                                        if (feild.visible === true) {
                                                            if(feild.title==='Date Of Counselling'){
                                                                return (<td className="text-capitalize" style={{ maxWidth: 165,width:165 }}>{feild.title}</td>)
                                                            }else{
                                                                return (<td className="text-capitalize">{feild.title}</td>)
                                                            }
                                                          
                                                        }
                                                    })}
                                                    </tr>
                                                </thead>
                                                <tbody className="">
                                                    {counseling_Data
                                                        .map((data, tkey) => {
                                                            return (
                                                                <tr key={tkey}>
                                                                    {counseling_head.map((head, Hkey) => {
                                                                        if (head['dataIndex'] === 's_no') {
                                                                            return (<td>{tkey + 1 + ((page_no - 1) * 20)}</td>)
                                                                        }
                                                                        if (head['dataIndex'] === 'date_of_counselling') {
                                                                            return (<td>{data[head['dataIndex']] ? data[head['dataIndex']] : '--'}</td>)
                                                                        }
                                                                        if (head['dataIndex'] === 'total_estimate_amt') {
                                                                            return (<td>{data[head['dataIndex']] ? data[head['dataIndex']] : '--'}</td>)
                                                                        }
                                                                        if (head['dataIndex'] === 'counselled_by') {
                                                                            return (<td>{data[head['dataIndex']] ? data[head['dataIndex']] : '--'}</td>)
                                                                        }
                                                                        if (head['dataIndex'] === 'privilege_name') {
                                                                            return (<td>{data[head['dataIndex']] ? data[head['dataIndex']] : '--'}</td>)
                                                                        }
                                                                        if (head['dataIndex'] === 'payment_type') {
                                                                            return (<td>{data[head['dataIndex']] ? data[head['dataIndex']] : '--'}</td>)
                                                                        }
                                                                        if(head['dataIndex'] === 'action') {
                                                                        return (<td className="text-capitalize"><Tooltip title="View Details"><img src={homepage+"/assets/images/view-border.png"} alt="view"  onClick={this.navigateTo.bind(this, data)} /></Tooltip></td>)
                                                                      
                                                                        }

                                                                    })}
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    {(counseling_Data && counseling_Data.length === 0) && <React.Fragment>
                                                        <tr>
                                                            <td colSpan={counseling_head.length}>
                                                                <Empty description={
                                                                    <span>
                                                                        No Data
                                                                    </span>
                                                                } />
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {/* <div className="col-12 justify-content-center align-item-center mx-0">
                                        <div className="col pagenation-col mb-3">
                                            <Pagination current={this.state.page_no} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={15} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />
                                        </div>
                                    </div> */}
                               
                                </TabPane>
                                <TabPane tab="Remarks" key="3">
                                    <div className="row">
                                        <div className="col mx-auto text-center bg-white">
                                            <img src={`${homepage}/assets/images/coming-soon.gif`}></img>
                                        </div>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </Spin>
                    <Modal
                        title=''
                        centere
                        footer={null}
                        width='95%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        destroyOnClose={true}
                        visible={commentModal}>
                        <Spin spinning={loadding} >
                            {commentModal &&
                                <React.Fragment>
                                    <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.addConsentModelClose()} /></Tooltip>
                                    <h4 className="text-center">Add Consent</h4>
                                    <div className="row  justify-content-center">
                                        <div class="col-12">
                                            <div className="financial-table table-responsive mt-5">
                                                {investigationSchema.map((feild, key) => {
                                                    if (feild.visible) {
                                                        return (<React.Fragment key={key}>
                                                            <div className="d-inline-flex  w-100">
                                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                                            </div>
                                                            <div className="financial-table table-responsive">
                                                                <Tableantd form_table={'investigation'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                            </div>
                                                        </React.Fragment>)
                                                    }
                                                })}
                                            </div>
                                            <div className="financial-table table-responsive mt-5">
                                                {drugsSchema.map((feild, key) => {
                                                    if (feild.visible) {
                                                        return (<React.Fragment key={key}>
                                                            <div className="d-inline-flex w-100">
                                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                                            </div>
                                                            <div className="financial-table table-responsive">
                                                                <Tableantd form_table={'drugs'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                            </div>
                                                        </React.Fragment>)
                                                    }
                                                })}
                                            </div>
                                            <div className="financial-table table-responsive mt-5">
                                                {proceduresSchema.map((feild, key) => {
                                                    if (feild.visible) {
                                                        return (<React.Fragment key={key}>
                                                            <div className="d-inline-flex w-100">
                                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                                            </div>
                                                            <div className="financial-table table-responsive">
                                                                <Tableantd form_table={'procedures'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                            </div>
                                                        </React.Fragment>)
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <button className="btn btn-success" onClick={() => { this.submitConsent() }}>Submit</button>
                                    </div>
                                </React.Fragment>
                            }
                        </Spin>
                    </Modal>
                    <Modal
                        title=''
                        centere
                        footer={null}
                        width='95%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        visible={consentdetalsvisible}>
                        <Spin spinning={loadding}>
                            <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.setState({ consentdetalsvisible: false, comments: null })} /></Tooltip>
                            <h4 className="text-center pb-4">Consent Details</h4>
                            <div className="row pb-3">
                                <div className="col-12 my-auto p-0">
                                    <h6 className="mb-0"> <Tooltip title="Consent ID">{data['consent_id'] ? data['consent_id'] : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="Nurse">{data['nurse'] ? data['nurse'] : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="Counsellor">{data['counsellor'] ? data['counsellor'] : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{data.umr_no ? data.umr_no : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{data.ip_no ? data.ip_no : '--'}</Tooltip></h6>
                                </div>
                            </div>
                            <div className="row ">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Investigations</h4>
                                <div className="financial-table table-responsive sticky-header" id="table">
                                    <table className="table table-hover table-bordered mb-0 bg-white">
                                        <thead className="table-header-bg-color">
                                            {investigations_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th>{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody className="">
                                            {investigations_body
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {investigations_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'investigation_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]) ? <div className="complete">Completed</div> : <div className="upcoming">Pending</div>}</td>)
                                                                }
                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                    // return ( <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(investigations_body && investigations_body.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={investigations_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row ">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Drugs</h4>
                                <div className="financial-table table-responsive sticky-header" id="table">
                                    <table className="table table-hover table-bordered mb-0 bg-white">
                                        <thead className="table-header-bg-color">
                                            {drug_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th>{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody className="">
                                            {durg_body
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {drug_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'drug_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'quantity') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'drug_price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]) ? <div className="complete">Completed</div> : <div className="upcoming">Pending</div>}</td>)
                                                                }

                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(durg_body && durg_body.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={drug_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row ">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Procedures</h4>
                                <div className="financial-table table-responsive sticky-header" id="table">
                                    <table className="table table-hover table-bordered mb-0 bg-white">
                                        <thead className="table-header-bg-color">
                                            {procedures_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th>{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody className="">
                                            {procedures_body
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {procedures_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'procedure_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }

                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]) ? <div className="complete">Completed</div> : <div className="upcoming">Pending</div>}</td>)
                                                                }
                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(procedures_body && procedures_body.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={procedures_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col text-center">
                                    <button className="btn btn-next" onClick={() => this.setState({ consentdetalsvisible: false, comments: null })}>Close</button>
                                </div>
                            </div>
                        </Spin>
                    </Modal>
{/* dropdwon */}
                    <Modal
                        title=''
                        centere
                        footer={null}
                        width='30%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        destroyOnClose={true}
                        visible={consentPrintVisibles}>
                        <Spin spinning={loadding} >
                                <React.Fragment>
                                    <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.consentPrintVisible(false)} /></Tooltip>
                                    <label className="data-label  text-center pl-5">Select Consent ID</label>
                                    <div className="row  justify-content-center">
                                        <div class="col-8">
                                        {<Select
                        // value={value ?feild_data.name==='care_management'?value.toString(): feild_data.text : (feild_data.type === 'single' ? null : [])}
                        // disabled={feild_data.disabled ? feild_data.disabled : false}
                        showSearch
                        // mode={feild_data.type}
                        style={{ width: '100%' }}
                        placeholder={'Select Consent'}
                        optionFilterProp="children"
                        // onSearch={this.fetchSearchData}
                        onChange={this.inputChange}
                        onFocus={this.onFocus.bind(this)}
                        showArrow={true}
                        allowClear={true}
                        loading={false}
                        dropdownMatchSelectWidth={false}
                        // notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    >
                        
                        {selet_options}
                    </Select>}
                                        </div>
                                    </div>
                                </React.Fragment>
                        </Spin>
                    </Modal>

                   {/* consent Print */}
                    <Modal
                                        // title="Clearance"
                                        centered
                                        visible={this.state.consentdetalsvisible_print}
                                        footer={null}
                                        onOk={() => this.setState({consentdetalsvisible_print:false})}
                                        onCancel={() => this.setState({consentdetalsvisible_print:false})}
                                        width='100%'
                                        zIndex={1021}
                                    >
                                        <Spin spinning={this.state.loadding}>
                                            <div ref={(el) => (this.componentRef = el)} >
                                                <React.Fragment>
                                                    <div className="fc-patient-copy">
                                                        <div className="p-4 bg-white" id="myH1">
                                                            <div className="clearfix">
                                                                <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                                                                {/* <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p> */}
                                                            </div>

                                                            <div>
                                                                <h1 className="text-p-bold text-center text-uppercase py-4">Consent Form</h1>
                                                            </div>
                                                            <div className="row pb-3">
                                <div className="col-3 my-auto ">
                                    <h6 className="mb-0">Consent ID : {data['consent_id'] ? data['consent_id'] : '--'}</h6>
                                    </div>
                                    <div className="col-3 my-auto ">
                                     <h6 >Nurse : {data['nurse'] ? data['nurse'] : '--'}</h6> 
                                  </div>
                                  <div className="col-3 my-auto capitalize_consent">
                                  <h6>Counsellor : {data['counsellor'] ? data['counsellor'] : '--'}</h6>
                                     </div> 
                                     <div className="col-3 my-auto ">
                                  <h6>UMR Number : {data.umr_no ? data.umr_no : '--'}</h6>
                                     </div> 
                                     <div className="col-3 my-auto pt-2  pr-0 pb-0">
                                  <h6>IP Number : {data.ip_no ? data.ip_no : '--'}</h6>
                                     </div> 
                            </div>
                                 <div className="row p-3">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Investigations</h4>
                                    <table className="table table-hover table-bordered ">
                                        <thead>
                                            {investigations_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th className="text-capitalize">{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody >
                                            {investigations_body_print
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {investigations_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'investigation_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]==='approve') ? 'Approved':'Rejected'}</td>)
                                                                }
                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                    // return ( <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(investigations_body_print && investigations_body_print.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={investigations_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                            </div>

                            <div className="row p-3">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Drugs</h4>
                                    <table className="table table-hover table-bordered ">
                                        <thead>
                                            {drug_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th className="text-capitalize">{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody >
                                            {durg_body_print
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {drug_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'drug_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'quantity') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'drug_price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]==='approve') ? 'Approved':'Rejected'}</td>)
                                                                }

                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(durg_body_print && durg_body_print.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={drug_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                            </div>

                            <div className="row p-3">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Procedures</h4>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            {procedures_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th className="text-capitalize">{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody>
                                            {procedures_body_print
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {procedures_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'procedure_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }

                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]==='approve') ? 'Approved':'Rejected'}</td>)
                                                                }
                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(procedures_body_print && procedures_body_print.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={procedures_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            </div>
                                            <div className="fc-patient-copy">
                                                <div className="row justify-content-center p-4 pt-4 m-0">
                                                    <ReactToPrint
                                                        // trigger={() => <a href="#">Print this out!</a>}
                                                        trigger={() => <button className="btn btn-success d-print-none text-capitalize">Print</button>}
                                                        content={() => this.componentRef}
                                                    />
                                                    <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({consentdetalsvisible_print:false})}>cancel</button>
                                                </div>
                                            </div>
                                        </Spin>
                                    </Modal>
                </div>
            </React.Fragment>);
    }
}

export default On_Bed_Patient_details;